export default __webpack_public_path__ + "static/media/guest_screenChange.89571764.svg";